
//import {db, functions} from "@/scripts/firebase";
import {Playground, Playing} from "@/common-datatypes";
import { Component,Mixins,Prop } from "vue-property-decorator"
import {query, Unsubscribe, onSnapshot, getDoc, where, limit, orderBy} from 'firebase/firestore'
import Common from '@/mixins/common'

@Component({
  components: {
    
  }
})


export default class PlayingList extends Mixins(Common) {
  @Prop({type: String, default: ''}) private playgroundId?: string

  observers: (Unsubscribe | undefined)[] = []

  playground = {} as Playground

  playings = [] as Playing[]

  isLoading = false

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      if(this.playgroundId){
        const playgroundDoc = await getDoc(this.$getPlaygroundDocRef(this.playgroundId))

        if(playgroundDoc.exists()){
          this.playground = {
            ...playgroundDoc.data() as Playground,
          }

          const playingsQuery = query(this.$getPlayingColRef(),where("playgroundId","==",this.playgroundId),limit(1),orderBy("updateTime","desc"))

          this.observers.push( onSnapshot(playingsQuery,async (snapshot) => {
            snapshot.forEach((doc) => {
              const row = {
                ...doc.data(),
              } as Playing

              const findIndex = this.playings.findIndex((playing) => {return playing.docId === doc.id})
              const deleteCount = (findIndex === -1 ? 0 : 1)
              this.playings.splice(findIndex,deleteCount,row)

              //playingsをupdateTimeでソート
              this.playings.sort((a,b) => {
                if(a.updateTime && b.updateTime){
                  return b.updateTime.getTime() - a.updateTime.getTime()
                }else{
                  return 0
                }
              })
            })
          
            this.$store.commit("setLoading",true);
            this.isLoading = true
            await this.$sleep(100)
            this.$store.commit("setLoading",false);
            this.isLoading = false
          }))
        }
      }
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  destroyed() {
    console.trace('destroyed')
    this.$unsubscriber(this.observers)
  }

}
